<template>
    <div class="ado-export__dashboard">
        <div class="ado-export__header">
            <h5 class="ado-export__header-title">Export</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <div class="ado-export__menu">
                <div class="row">
                    <div class="col-lg-8 ado-export__settings">
                        <div class="ado-export__title">Export Settings</div>
                        <form id="exportFilter" ref="exportFilter" @submit.prevent="download()">
                            <input type="hidden" name="mode" id="mode" value="export">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="date">Start Date <small
                                                class="text-danger">*Required</small></label>
                                        <datepicker v-model="exportDate.start" id="startDate" name="startDate"
                                            v-on:selected="disableTo" :disabled-dates="exportDate.startState"
                                            format="yyyy-MM-dd" required>
                                        </datepicker>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="date">End Date <small class="text-danger">*Required</small></label>
                                        <datepicker v-model="exportDate.end" id="endDate" name="endDate"
                                            v-on:selected="disableFrom" :disabled-dates="exportDate.endState"
                                            format="yyyy-MM-dd" required>
                                        </datepicker>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label for="type">Type <small class="text-danger">*Required</small></label>
                                        <select v-model="type" class="form-control form-control-sm" id="type"
                                            name="type" required>
                                            <option value="all">All</option>
                                            <option value="queue">Queue</option>
                                            <option value="dequeued">Dequeued</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div v-if="exportAlert" :class="['mb-2', 'text-right', setExportAlert]">
                            <i v-if="exportType == 'success'" class="far fa-check"></i><i v-else
                                class="far fa-exclamation-circle"></i> {{ exportMessage }}
                        </div>
                        <button type="button" class="btn btn-sm btn-primary float-right" @click="download()">
                            <i v-if="!exportStatus" class="far fa-cloud-download"></i><i v-else
                                class="fas fa-spinner fa-spin"></i> Generate File</button>
                    </div>
                    <div class="col-g-4">
                        <!-- EMPTY -->
                    </div>
                </div>
            </div>
            <!-- <div class="ado-export__content">
                <div class="ado-export__header">
                    <h5 class="ado-export__header-title">History</h5>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'ado-admin-export',
    components: {
        Datepicker
    },
    data() {
        return {
            exportDate: {
                start: new Date(),
                end: new Date(),
                startState: {
                    from: new Date()
                },
                endState: {
                    to: new Date()
                }
            },
            exportAlert: false,
            exportMessage: '',
            exportStatus: false,
            exportType: '',
            type: 'all'
        }
    },
    methods: {
        disableFrom(val) {
            this.exportDate.startState.from = val
        },
        disableTo(val) {
            this.exportDate.endState.to = val
        },
        download() {
            const that = this;
            let startDate = this.exportDate.start.toISOString().slice(0, 10).replace(/\-/g, "");
            let endDate = this.exportDate.end.toISOString().slice(0, 10).replace(/\-/g, "");
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?export&department=${DEPARTMENT}&startDate=${startDate}&endDate=${endDate}&type=${this.type}`;

            // Set alert and loader
            this.exportAlert = true;
            this.exportStatus = true;
            this.exportMessage = 'The CSV file has been successfully generated based on the specified export settings.';
            this.exportType = 'success';

            // Download streamer
            window.open(api);

            if (this.exportStatus) {
                setTimeout(function () {
                    that.exportStatus = false;
                }, 2000);
            }
        }
    },
    computed: {
        setExportAlert: function () {
            return {
                active: this.isActive && !this.error,
                'text-danger': this.exportType.match(/danger/i),
                'text-warning': this.exportType.match(/warning/i),
                'text-success': this.exportType.match(/success/i),
                'text-primary': !this.exportType
            }
        }
    }
}
</script>

<style>
.ado-export__content {
    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
    padding: 1.25rem;
}

.ado-export__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.ado-export__header-title {
    font-weight: 600;
    margin: 0;
}

.ado-export__menu {
    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
    padding: 1.25rem;
}

.ado-export__settings {
    border-right: 1px solid #eff0f6;
}

.ado-export__title {
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 1rem;
}

@media (max-width: 991.98px) {
    .ado-export__settings {
        border: none;
        border-bottom: 1px solid #eff0f6;
        margin-bottom: 1rem;
        padding-bottom: 1rem;
    }
}
</style>